import { Routes, Route } from "react-router-dom";
import Home from "./components/Home/Home";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Chatbot from "./components/Chatbot/Chatbot";

function Main() {
  return (
    <div className="Main">
      <Header />   
      <Routes>
        <Route path='/' element={<Home />} />
      </Routes>
      <Footer/>
      <Chatbot />
    </div>
  );
}

export default Main;
